import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { AccessPermissionService } from '../service/access-permission.service';

@Directive({
  selector: '[appAccessPermission]',
})
export class AccessPermissionDirective implements OnInit {
  @Input() appAccessPermission: string = '';
  @Input() permissionType: string = '';

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private accessService: AccessPermissionService
  ) {}

  ngOnInit() {
    // Get permissions using the consolidated service method
    const canView = this.accessService.hasPermission(
      'view',
      this.appAccessPermission,
      this.permissionType
    );
    const canEdit = this.accessService.hasPermission(
      'edit',
      this.appAccessPermission,
      this.permissionType
    );

    // Apply view-only restrictions
    if (canView && !canEdit) {
      // Make input read-only
      this.renderer.setAttribute(this.el.nativeElement, 'readonly', 'true');
      this.renderer.addClass(this.el.nativeElement, 'view-only');

      // Disable buttons, selects, etc.
      if (
        this.el.nativeElement.tagName === 'BUTTON' ||
        this.el.nativeElement.tagName === 'SELECT'
      ) {
        this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');
      }
    }

    // Hide element if user doesn't have view access
    if (!canView) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    }
  }
}
